import React, { Component } from "react"
import { withStyles } from "@material-ui/core/styles"
import ErrorIcon from "@material-ui/icons/Error"
import InfoIcon from "@material-ui/icons/Info"
import CloseIcon from "@material-ui/icons/Close"
import IconButton from "@material-ui/core/IconButton"
import Snackbar from "@material-ui/core/Snackbar"
import green from "@material-ui/core/colors/green"
import "../styles/ComponentBase/SnackBar.css"

const variantIcon = {
  error: ErrorIcon,
  info: InfoIcon,
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: green[600],
  },
})

class SnackBar extends Component {
  constructor(props) {
    super(props)

    this.state = { msgOpen: true }
  }

  componentDidMount() {
    this.setState({ msgOpen: true })
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    if (this.props.userMessage !== "" && this.props.userMessage !== prevProps.userMessage) {
      this.setState({ msgOpen: true })
    }
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return
    }

    this.setState({ msgOpen: false })
    if (this.props && this.props.handleMessageDialogClosed) {
      this.props.handleMessageDialogClosed(false)
    } else {
      console.log("calling close dialog before props")
    }
  }

  render() {
    const { classes } = this.props
    const Icon = variantIcon[this.props.msgBGColor]
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className="snackBar"
        open={this.state.msgOpen}
        autoHideDuration={2000}
        onClose={this.handleClose}
        ContentProps={{
          "aria-describedby": "snackbar-message-id",
          classes: {
            root: classes[this.props.msgBGColor],
          },
        }}
        message={
          <span id="snackbar-message-id" className="message">
            <Icon className="msgIconVariant" />
            {this.props.userMessage}
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className="close"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>
          </span>
        }
      />
    )
  }
}

export default withStyles(styles)(SnackBar)
